var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "DatetimePicker",
    _vm._g(
      _vm._b(
        {
          attrs: {
            lang: _vm.lang,
            "first-day-of-week": _vm.firstDay,
            format: "YYYY-MM-DD HH:mm",
            formatter: _vm.formatter,
            value: _vm.date,
            type: _vm.type,
            clearable: false,
            "minute-step": 5,
            "disabled-date": _vm.disabledDate,
            "show-second": false,
            "show-time-panel": _vm.showTimePanel,
            "show-week-number": _vm.showWeekNumbers,
            use12h: _vm.showAmPm,
            "append-to-body": _vm.appendToBody
          },
          on: { close: _vm.close, change: _vm.change, pick: _vm.pickDate },
          scopedSlots: _vm._u(
            [
              {
                key: "icon-calendar",
                fn: function() {
                  return [
                    _c("button", {
                      staticClass: "datetime-picker-inline-icon icon",
                      class: {
                        "icon-timezone": !_vm.isAllDay,
                        "icon-new-calendar": _vm.isAllDay,
                        "datetime-picker-inline-icon--highlighted":
                          _vm.highlightTimezone
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.toggleTimezonePopover($event)
                        },
                        mousedown: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return (function() {})($event)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "Popover",
                      {
                        attrs: {
                          open: _vm.showTimezonePopover,
                          "open-class": "timezone-popover-wrapper"
                        },
                        on: {
                          "update:open": function($event) {
                            _vm.showTimezonePopover = $event
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "timezone-popover-wrapper__title" },
                          [
                            _c("strong", [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.$t(
                                      "calendar",
                                      "Please select a timezone:"
                                    )
                                  ) +
                                  "\n\t\t\t\t"
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("TimezoneSelect", {
                          staticClass:
                            "timezone-popover-wrapper__timezone-select",
                          attrs: { value: _vm.timezoneId },
                          on: { change: _vm.changeTimezone }
                        })
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              },
              !_vm.isAllDay
                ? {
                    key: "footer",
                    fn: function() {
                      return [
                        !_vm.showTimePanel
                          ? _c(
                              "button",
                              {
                                staticClass: "mx-btn mx-btn-text",
                                on: { click: _vm.toggleTimePanel }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t" +
                                    _vm._s(_vm.$t("calendar", "Pick a time")) +
                                    "\n\t\t"
                                )
                              ]
                            )
                          : _c(
                              "button",
                              {
                                staticClass: "mx-btn mx-btn-text",
                                on: { click: _vm.toggleTimePanel }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t" +
                                    _vm._s(_vm.$t("calendar", "Pick a date")) +
                                    "\n\t\t"
                                )
                              ]
                            )
                      ]
                    },
                    proxy: true
                  }
                : null
            ],
            null,
            true
          )
        },
        "DatetimePicker",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }